var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.setClassName,attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.buttonName)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }